module.exports = __webpack_public_path__ + "static/media/bg3.e76de24b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg3.jpg
// module id = 5871
// module chunks = 0